import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { wrapFormComponentWithLabelAndError } from './StyledFormComponentWrappers';
import { RawSimpleCheckboxField } from './SimpleCheckboxField';
import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';
import { wrapFormComponentWithError } from './StyledFormComponentWrappers';

const RawCheckboxGroup = ({ options, value: values, onChange, ...otherInputProps }) => {
  const isChecked = val => values.includes(val);
  const toggleCheckedValue = val => () => {
    if (!isChecked(val)) {
      onChange(values.concat([val]));
    }
    if (isChecked(val)) {
      onChange(_.filter(values, v => v !== val));
    }
  };

  return (
    <div>
      {options.map(option => (
        <RawSimpleCheckboxField
          key={option.value}
          name={option.value}
          label={option.label}
          checked={isChecked(option.value)}
          onChange={toggleCheckedValue(option.value)}
        />
      ))}
    </div>
  );
};

RawCheckboxGroup.displayName = 'RawCheckboxGroup';

RawCheckboxGroup.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
};

export { RawCheckboxGroup };

const RawCheckboxGroupField = wrapFormComponentWithLabelAndError(RawCheckboxGroup);
RawCheckboxGroupField.displayName = 'RawCheckboxGroupField';

const Connected = connectFormComponentToReduxForm(RawCheckboxGroupField);

const CheckboxGroupField = props => <Connected defaultValue={[]} {...props} />;
CheckboxGroupField.displayName = 'CheckboxGroupField';
export default CheckboxGroupField;

const CheckboxGroupInputWithoutDefaultValueYet = connectFormComponentToReduxForm(
  wrapFormComponentWithError(RawCheckboxGroup)
);
const CheckboxGroupInput = props => (
  <CheckboxGroupInputWithoutDefaultValueYet defaultValue={[]} {...props} />
);

export { CheckboxGroupInput };
